// 基础地址
const baseURL = 'https://www.zkjan.com/kstk-api/netuser/';
const base = 'https://www.zkjan.com/';
const xcxBase = 'https://www.zkjan.com/kstk-api/applet1/';

// const baseURL = 'http://localhost/kstk-api/netuser/';
// const base = 'http://localhost/';
// const xcxBase = 'http://localhost/kstk-api/applet1/';


function goLogin(type,isReturn) {
	const t = type || 1;
	// location.href = base + 'pages/login/login.html?type=' + t + '&href=' + encodeURIComponent(location.href);
	
	localStorage.setItem('originalHref',location.href) 
	var url = '/login.html'
	if(t==2){
		url = '/register.html'
	}
	var href = loginRealm + url +'?redirect_uri=' + encodeURIComponent(oauthUrl)+'&appid='+appid
	if(isReturn){
		return href
	}else{
		location.href = href
	}
};
// 请求参数格式
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// 请求拦截
axios.interceptors.request.use( config => {
	return config;
}, function (err) {
	return Promise.reject(err);
});
// 响应拦截
axios.interceptors.response.use( res => {
	let resData = res.data;
	// switch (resData.code - 0) {
	// 	case -1:
	// 		resData.msg && alert(resData.msg);
	// 		break;
	// 	default:
	// 		break;
	// }
	return resData;
}, function (err) {
	return Promise.reject(err);
});

// 时间格式过滤器(年-月-日 时:分 / 2008-12-31 12:00)
Vue.filter('time', value => {
	let date = new Date(value);
	let	Y = date.getFullYear();
	let	m = date.getMonth() + 1;
	let	d = date.getDate();
	let	H = date.getHours();
	let	i = date.getMinutes();
	if (m < 10) {
		m = '0' + m;
	}
	if (d < 10) {
		d = '0' + d;
	}
	if (H < 10) {
		H = '0' + H;
	}
	if (i < 10) {
		i = '0' + i;
	}
	return Y + '-' + m + '-' + d + ' ' + H + ':' + i;
});
// 时间格式过滤器(年-月-日 / 2008-12-31)
Vue.filter('date', value => {
	let date = new Date(value);
	let	Y = date.getFullYear();
	let	m = date.getMonth() + 1;
	let	d = date.getDate();
	if (m < 10) {
		m = '0' + m;
	}
	if (d < 10) {
		d = '0' + d;
	}
	return Y + '-' + m + '-' + d;
});
// 数字转中文(一至十)
Vue.filter('chinaNum', index => {
	return ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'][index];
});

/**
*获取url参数
*@param {string} key 参数的key
*/
Vue.prototype.getQueryString = key => {
	let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
	let r = window.location.search.substr(1).match(reg);
	if (r != null) {
		return decodeURI(r[2]);
	}
	return null;
};
/**
 *验证是否登录
 */
Vue.prototype.checkLogin = (callback) => {
	let user = {};
	axios.post(baseURL + 'checkCookies')
		.then(res => {
			if (res.code == 200) {
				user.carCount = res.carCount;
				user.user = res.list;
				user.majorlist = res.majorlist;
			}
			if (res.code == -1) {
				user = null;
			}
			if (typeof callback == 'function') {
				callback(user);
			}
		})
		.catch(err => console.log(err));
};
/**
 *跳转登录
 */
Vue.prototype.goLogin = goLogin
/**
 *验证手机号
 *@param {string} tel 手机号码
 */
Vue.prototype.isPhoneNumber = tel => {
	let reg = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[0-9])[0-9]{8}$/;
	return reg.test(tel);
};

/**
 *窗口滚动
 *@param {number} top 要滚动到的顶部位置
 */
Vue.prototype.scrollTo = top => {
	document.documentElement.scrollTop += 1;
	let i = 1;
	let b = document.documentElement.scrollTop ? document.documentElement : document.body;
	let s = (top - b.scrollTop) / 20;
	let stop = setInterval(() => {
		if (++i > 20) {
			b.scrollTop = top;
			clearInterval(stop);
			return;
		}
		b.scrollTop += s;
	}, 20);
};

/**
 *窗口滚动
 *@param {number} el 要滚动的元素
 *@param {number} top 要滚动到的顶部位置
 *@param {number} duration 滚动时长,单位：毫秒
 */
Vue.prototype.scroll = (el, top, duration) => {
    let s = top / duration;
    let temp = null;
    let stop = setInterval(() => {
        if (el.scrollTop >= top || el.scrollTop === temp) {
            el.scrollTop = top;
            clearInterval(stop);
            return;
        }

        temp = el.scrollTop;
        el.scrollTop += Math.ceil(s*20);
    }, 20);
};

/**
 *刷新页面
 */
Vue.prototype.reload = () => {
	location.reload();
};

/**
 *查询IE版本
 */
Vue.prototype.getIEVer = () => {
    const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    const isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
    const isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
    const isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
    if(isIE) {
        const reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        const fIEVersion = parseFloat(RegExp["$1"]);
        if(fIEVersion == 7) {
            return 7;
        } else if(fIEVersion == 8) {
            return 8;
        } else if(fIEVersion == 9) {
            return 9;
        } else if(fIEVersion == 10) {
            return 10;
        } else {
            return 6;//IE版本<=7
        }
    } else if(isIE11) {
        return 11; //IE11
    }else{
        return -1;//不是ie浏览器
    }
}

/**
 *获取星期
 */
Vue.prototype.getDay = day => {
    return ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][day];
};


/**
 *手机号正则
 */
 Vue.prototype.regPhone = /^1(3|4|5|6|7|8|9)\d{9}$/

 /**
  *手机号输入框检测
  */
  Vue.prototype.registerPhoneInput = function(type='registerPhone'){
   if(this[type]){
	 if(!this.regPhone.test(this[type])){
	   this[type+'Tips'] = '请输入正确的手机号'
	   return false
	 }else{
	   this[type+'Tips'] = ''
	   return true
	 }
   }else{
	 this[type+'Tips'] = '请输入手机号'
	 return false
   }
 }
 
 /**
  *输入框检测
  */
  Vue.prototype.verificationInput = function(type,tipsText){
   if(this[type]){
	 this[type+'Tips'] = ''
	 return true
   }else{
	 this[type+'Tips'] = tipsText
	 return false
   }
 }
 
 /**
  *金钱输入框检测
  */
  Vue.prototype.verificationMoney = function(e,type,tipsText){
   var value = e.target.value.toString();
   if(value){
	 var value2 = this.formatPrice(value);
	 if(value!=value2){
	   this.$nextTick(function(){
		 e.target.value = value2;
	   })
	 }
   }
   if(this[type]){
	 this[type+'Tips'] = ''
	 return true
   }else{
	 this[type+'Tips'] = tipsText
	 return false
   }
 }
 
 Vue.prototype.formatPrice =function(value){
   value = value.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
   value = value.replace(/^\./g, '')// 验证第一个字符是数字而不是字符
   value = value.replace(/\.{2,}/g, '.')// 只保留第一个.清除多余的
	 value = value.replace(/^0(\d)/g,'$1');
   value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
   value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')// 只能输入两个小数
   return value
  }
 